'use client';

import { useEffect } from 'react';
import useStore from '.';
import { CompanyDetails } from '_services/common.service';
import { Category } from '@/components/catelog/category-card';

interface ClientInitializerProps {
  updateCompanyDetails: CompanyDetails | null;
  categories?: Category[] | [];
  deals?: Category[] | [];
  children?: React.ReactNode;
}


export default function ClientInitializer({ updateCompanyDetails, categories, deals, children }: ClientInitializerProps) {
  const { setCompanyDetails, setCategories } = useStore();

  useEffect(() => {
    // console.log("Company Details:", companyDetails);

    if (updateCompanyDetails) {
      setCompanyDetails(updateCompanyDetails);
    }
  }, [updateCompanyDetails, setCompanyDetails]);

  useEffect(() => {
    // console.log("Categories:", categories);

    if (categories && categories.length > 0) {
      setCategories(categories);
    }
  }, [categories, setCategories]);

  useEffect(() => {
    // console.log("Deals:", deals);
    if (deals && deals.length > 0) {
      const { setDeals } = useStore.getState();
      setDeals(deals);
    }
  }, [deals]);

  // console.log("ClientInitializer Rendered with Company Details:", companyDetails);
  

  return <>
    {children}
  </>; // this just initializes state
}